import React from "react";

export default function Footer() {
  return (
    <footer style={{marginLeft:"260px"}} className="bg-transparent text-center font-medium text-slate-600 dark:text-slate-400 print:hidden border-t dark:border-slate-700/40 flex-shrink-0">
      <div className="container mx-auto px-4 py-4 h-[52px] flex items-center justify-between">
        <div className="text-sm">© 2025 Excellent</div>
        <div className="hidden md:inline-block text-sm text-slate-600 dark:text-slate-400">
          Crafted with <i className="ti ti-heart text-red-500" /> by Mannatthemes
        </div>
      </div>
    </footer>
  );
}